import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from '../config';

function DepartmentList({ refreshKey }) {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete?")) return;

    const token = localStorage.getItem("token");
    try {
      await axios.delete(`${BASE_URL}/department/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Reload list
      setDepartments(departments.filter((dept) => dept.id !== id));
    } catch (error) {
      alert("Delete failed");
    }
  };

  const startEdit = (dept) => {
    setEditId(dept.id);
    setEditName(dept.name);
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.put(
        `${BASE_URL}/department/${editId}`,
        {
          depertmentname: editName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Reload list after update
      setDepartments(
        departments.map((dept) =>
          dept.id === editId ? { ...dept, name: editName } : dept
        )
      );

      setEditId(null);
      setEditName("");
    } catch (error) {
      alert("Update failed");
    }
  };

  useEffect(() => {
    const fetchDepartments = async () => {
      const token = localStorage.getItem("token"); // get token from localStorage
      try {
        // 2. Make authenticated request
        const response = await axios.get(
          `${BASE_URL}/departments`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setDepartments(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching departments:", error);
        setLoading(false);
      }
    };

    fetchDepartments();
  }, [refreshKey]);

  return (
    <div>
      <h2>Department List</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="table table-striped mb-0">
          <thead>
            <tr>
              <th>Sl</th>
              <th>Department Name</th>
              <th class="text-end">Action</th>
            </tr>
          </thead>
          <tbody>
            {departments.map((dept, index) => (
              <tr key={dept.id}>
                <td>{index + 1}</td>
                <td>
                  {editId === dept.id ? (
                    <input
                      type="text"
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                    />
                  ) : (
                    dept.name
                  )}
                </td>
                <td className="text-end">
                  {editId === dept.id ? (
                    <>
                      <button
                        onClick={handleUpdate}
                        className="btn btn-sm btn-success me-2"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => setEditId(null)}
                        className="btn btn-sm btn-secondary"
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <i
                        className="las la-pen text-secondary font-16 me-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => startEdit(dept)}
                      ></i>
                      <i
                        className="las la-trash-alt text-danger font-16"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(dept.id)}
                      ></i>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default DepartmentList;